import React, {useState} from "react";

const ErrorModal = ({showErrorModal, setShowErrorModal, errorMessage}) => {

    const handleClick = () => {
        setShowErrorModal(false);
        window.close();
    }

    return (
        <>
            {showErrorModal ? (
                <>

                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div
                                className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div
                                    className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Corrigir Erro</h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{overflowY: "auto", maxHeight: "70vh"}}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessage}</div>

                                </div>

                                {/* Modal Footer */}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleClick}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Perto
                                    </button>

                                </div>
                            </div>
                        </div>


                    </div>


                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
}

export default ErrorModal;